module.exports = __webpack_public_path__ + "img/03_Button-4.3e95ac9b.png";